import {
  CreatePlanPayload,
  UpdatePlanPayload,
  TogglePlanStatusPayload,
  PlanQueryParams,
  GetPlansResponse,
  GetUserSubscriptionPlanResponse,
  CreatePlanResponse,
  UpdatePlanResponse,
  TogglePlanStatusResponse,
  GetPlanByIdResponse,
  ActiveSubscribersResponse,
  PlanUsersResponse,
  DeletePlanResponse,
  PaginatedResponse,
  Plan,
  CancelSubscriptionResponse,
  CancelSubscriptionPayload,
} from "./subscription.types";
import { axiosWithToken } from "@/utils/axios";

class SubscriptionService {
  // ─────────────────────────────────────────────
  // Customer-Facing
  // ─────────────────────────────────────────────

  GetPlans() {
    return axiosWithToken().get<GetPlansResponse>("/subscription/plans");
  }

  GetUserSubscriptionPlan() {
    return axiosWithToken().get<GetUserSubscriptionPlanResponse>(
      "/subscription/user/plan",
    );
  }

  CancelSubscription(payload?: CancelSubscriptionPayload) {
    return axiosWithToken().delete<CancelSubscriptionResponse>(
      "/subscription/user/cancel",
      { data: payload },
    );
  }

  // ─────────────────────────────────────────────
  // Admin: Plan CRUD
  // ─────────────────────────────────────────────

  CreatePlan(payload: CreatePlanPayload) {
    return axiosWithToken().post<CreatePlanResponse>(
      "/subscription/plan",
      payload,
    );
  }

  UpdatePlan(id: string, payload: UpdatePlanPayload) {
    return axiosWithToken().patch<UpdatePlanResponse>(
      `/subscription/plan/${id}`,
      payload,
    );
  }

  TogglePlanStatus(id: string, payload: TogglePlanStatusPayload) {
    return axiosWithToken().patch<TogglePlanStatusResponse>(
      `/subscription/plan/${id}/status`,
      payload,
    );
  }

  GetAllPlans(params?: PlanQueryParams) {
    return axiosWithToken().get<PaginatedResponse<Plan>>("/subscription/plan", {
      params,
    });
  }

  GetPlanById(id: string) {
    return axiosWithToken().get<GetPlanByIdResponse>(
      `/subscription/plan/${id}`,
    );
  }

  DeletePlan(id: string) {
    return axiosWithToken().delete<DeletePlanResponse>(
      `/subscription/plan/${id}`,
    );
  }

  // ─────────────────────────────────────────────
  // Admin: Subscribers
  // ─────────────────────────────────────────────

  GetActiveSubscribers() {
    return axiosWithToken().get<ActiveSubscribersResponse>(
      "/subscription/plan/users",
    );
  }

  GetPlanUsers(planId: string) {
    return axiosWithToken().get<PlanUsersResponse>(
      `/subscription/plan/${planId}/users`,
    );
  }
}

const subscriptionService = new SubscriptionService();
export default subscriptionService;
